import axios from "axios";
import { BASE_URL } from "./constant";

export const httpClient = axios.create({
  baseURL: BASE_URL,
  timeout: 60000
});
httpClient.defaults.headers.common['Content-Type'] = 'application/json';
